import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import onboardingEnglish from '../components/translations/onboarding/en.json';
import onboardingSpanish from '../components/translations/onboarding/es.json';
import onboardingPortuguese from '../components/translations/onboarding/pt.json';
import english from './languages/en.json';
import spanish from './languages/es.json';
import portuguese from './languages/pt.json';

const resources = {
  en: {
    translation: { ...english, ...onboardingEnglish },
  },
  es: {
    translation: { ...spanish, ...onboardingSpanish },
  },
  pt: {
    translation: { ...portuguese, ...onboardingPortuguese },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'es',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
